module.exports = __webpack_public_path__ + "img/28_39.0c43b2a0.png";